import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useWebRTC } from '@/shared/services/jssip'
import { GUEST_ROOM_CHAT } from '@/shared/utils/constants'

export const callGuestSessionBeforeEnter = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  const { sessionId } = to.params
  const { getRTCSessionFacadeById } = useWebRTC()

  if (sessionId && typeof sessionId === 'string' && getRTCSessionFacadeById(sessionId)) {
    next()
  } else {
    next({ name: GUEST_ROOM_CHAT })
  }
}
